<template>
  <Button
    :loading="loading"
    loadingText="提交中..."
    type="danger"
    text="下一步"
    :disabled="isDisabled"
    class="nextStep"
    :click="preClick"
  />
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import Button from './Button.vue';
import { Dialog } from 'vant';

export default {
  name: 'NextButton',
  data() {
    return {
      isDisabled: true,
      loading: false,
      productName: ''
    };
  },
  props: ['params', 'errorMessage', 'allowClearHandler', 'form'],
  components: {
    Button,
  },
  computed: {
    ...mapState({
      publicPage(val) {
        return val.publicPage;
      },
    }),
  },
  mounted() {
    this.getBankNameByProduct();
  },
  methods: {
    ...mapMutations('publicPage', ['updateState']),
    ...mapActions('publicPage', ['getUserInfo']),
    // 获取该产品所属服务银行名称
    getBankNameByProduct() {
      this.$api.PublicPage.getBankNameByProduct({
        productId: this.$route.query.productId,
      }).then((res) => {
        this.productName = res.data.productName || '';
      });
    },
    preClick() {
      if(this.$route.query.productId === 'SPDB-FPD') {
        Dialog.confirm({
          title: '产品须知',
          message: `${this.productName}由系统自动审批，全流程需本人办理。该业务除贷款利息及担保公司担保费外，无其他任何费用，也不会委托中介机构或个人代理向您收取费用，任何以帮您办理贷款为由，向您索要费用的行为均属欺骗。`,
          confirmButtonText: '阅读并知晓',
          messageAlign: 'left',
          cancelButtonText: '取消',
        }).then(() => {
          this.onSubmit();
        });
      } else {
        this.onSubmit();
      }
    },
    onSubmit() {
      this.$toast.loading({
        message: '加载中...',
        clear: true,
        forbidClick: true,
        loadingType: 'spinner',
      });
      this.isDisabled = true;
      const obj = this.form.getState();
      // eslint-disable-next-line no-underscore-dangle
      const contract = this.form._currentState.Contract;
      const params = {
        productId: this.$route.query.productId,
        corpName: obj.corpName, // 无企业时为空
        taxNo: obj.taxNo, // 无企业时为空
        userType: obj.borrowerType, // 申请人类型，// 无企业时为空
        userName: obj.borrowerName, // 姓名
        identity: obj.borrowerIdentity, // 身份证
        phone: obj.borrowerPhone, // 手机号
        referrer: obj.referrer, // 邀请码
        captcha: '', // 短信校验码，无校验时为空
        typeList: contract ? contract.props.list.map((v) => v.value) : [], // 授权书
      };
      this.$api.PublicPage.nextProductConfig(params).then((res) => {
        // 提交接口后，更新当前用户是否实名，实名之后不能修改姓名和手机号
        this.getUserInfo();
        if (res.success) {
          // 切换tab页面
          // 如果之前没有绑定企业，第一次绑定成功需要将corpId存起来
          if (res.data?.corpId) {
            this.updateState({
              submitInfoAll: {
                ...this.publicPage.submitInfoAll,
                corpId: res.data.corpId,
              },
            }); 
          }
          this.updateState({
            tabActive: 2,
          });
          this.$toast.clear();
          this.isDisabled = false;
        } else {
          this.$toast.clear();
          this.isDisabled = false;
          this.$toast.fail({
            message: res.returnMessage,
            forbidClick: true,
          });
        }
      }).catch((err) => {
        this.$toast.clear();
        this.isDisabled = false;
        this.$toast.fail({
          message: '网络异常，请稍后再试！',
          forbidClick: true,
          duration: 2500,
        });
      });
    },
  },
  watch: {
    'form.passThrough': {
      handler() {
        this.isDisabled = this.form.passThrough;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style scoped></style>
